import React, { useState, useEffect, useRef } from "react";
import { AutoCompleteComponent } from "@syncfusion/ej2-react-dropdowns";
import useUtils from "services/utils/useUtils";
import { useFormContext, Controller, useWatch } from "react-hook-form";
import { get } from 'lodash';

interface IInputProps {
    name: string;
    required?: string;
    disabled?: boolean;
    xl?: number;
    md?: number;
    col?: number;
    isAutonomo?: any;
}

const InputRegimenFormularios: React.FC<IInputProps> = ({
    name,
    required,
    disabled,
    xl,
    md,
    col,
    isAutonomo,
}) => {
    const [data, setData] = useState<any>(null);
    const [desc, setDesc] = useState<any>(null);
    const ref = useRef<HTMLDivElement>(null); 
    const { getRegimenesFormulario } = useUtils();
    const {
        register,
        control,
        formState: { errors },
        setValue,
    } = useFormContext();

    const errorMessage = get(errors, name)?.message;
    const watchDesc = useWatch({ name });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const regimenesData = await getRegimenesFormulario();
                setData(regimenesData);
            } catch (error) {
                console.error("Error al obtener regimenes:", error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (data && watchDesc) {
            const watchDescString = watchDesc.toString();
            const number =
                watchDescString.length === 3 ? `0${watchDescString}` : watchDescString;

            const selectedDesc = data.find((i) => i.Codigo === number);
            setDesc(selectedDesc || null);

            if (selectedDesc) {
                setValue(name + "Descripcion", selectedDesc.Descripcion);
            }
        }
    }, [data, watchDesc, setValue, name]);

    useEffect(() => {
        register(name + "Descripcion");
    }, [register, name]);

    return (
        <div ref={ref} data-input-name={name} className={`col-xl-${xl} col-md-${md} col-${col} mt-2`}>
            <fieldset className={`input-block input-block--code`}>
                <div className="container-leyend">
                    <legend className="input-block--code__legend">
                        Regimen Seguridad Social
                    </legend>
                </div>
                <div className="container-inputs-cno-code">
                    <Controller
                        name={name}
                        control={control}
                        rules={{ required }}
                        render={({ field }) => (
                            <AutoCompleteComponent
                                dataSource={data}
                                fields={{ value: "Descripcion" }}
                                placeholder="Introduzca una letra para que aparezca el desplegable"
                                change={(e) => {
                                    const codigo = e.itemData?.Codigo;
                                    const descripcion = e.itemData?.Descripcion;

                                    field.onChange(codigo);
                                    setDesc(e.itemData);
                                    setValue(name + "Descripcion", descripcion);

                                    if (typeof isAutonomo === "function") {
                                        isAutonomo(e.itemData?.EsAutonomo);
                                    }
                                }}
                                value={desc?.Descripcion}
                                enabled={!disabled}
                            />
                        )}
                    />
                </div>

                {errorMessage && <p className="error m-0">{errorMessage as any}</p>}
            </fieldset>
        </div>
    );
};

export default InputRegimenFormularios;
